module.exports = __webpack_public_path__ + "static/media/Liberian-Registry-logo.14ad8ccd.png";